import React, { useEffect, useState } from "react";
import Space from "../../layout/Space";
import PrimaryButton from "../../buttons/PrimaryButton";
import Icon1 from "../../icons/Icon.js";
import { useAuth } from "../../auth/FirebaseAuth";
import { useSnackbar } from "notistack";
import { doc } from "firebase/firestore";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import { getOrgById, isColorTooDark } from "../../models/OrgFunctions.js";
import SecondaryButton from "../../buttons/SecondaryButton";
import Modal1 from "../../modals/Modal1.js";

import { useAppContext } from "../../config/AppContext.js";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";
import { HexColorPicker } from "react-colorful";
import {
  flutterColorToHex,
  HexColorToFlutter,
} from "../../models/ColorFunctions.js";
import TextField2T from "../../textfields/TextField2T";
import { dbCentral } from "../../config/FirebaseConfig";

// Account Component
function Tags({ userData, orgData, navigateWorkspace }) {
  const { currentUser } = useAuth();
  const [token, setToken] = useState(null);
  const [tags, setTags] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isColorOpen, setIsColorOpen] = useState(false);
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [nom, setNom] = useState(null);
  const [ideas, setIdeas] = useState([
    "urgent",
    "doc à transmettre",
    "en cours de finalisation",
    "vérifier MAJ",
    "AFC-50",
    "attente maj",
    "faire DPE + ATF",
    "DPE + ATF ok",
    "VMC ok",
    "faire VMC",
    "ATT PHOTO VMC",
    "ATT ath spe signée",
    "Problème paiement",
    "Problème XML",
    "Faire ATF",
    "ATT ATH",
    "ATT REVISITE POUR MAJ",
    "ATT accord PC",
    "PERMEA OK",
    "att fiche extension",
    "PERMEA",
    "FAIRE DPE",
    "DPE OK",
    "FAIRE RAPPORT PERMEA",
    "ATT RGLMT",
    "ATT PMR",
    "PRET A ETRE ENVOYE",
    "ATS -50 PC",
  ]);

  // Fetch the token asynchronously using useEffect
  useEffect(() => {
    handleFetchData(); // Call the function
  }, [currentUser]); // Run this effect only when currentUser changes

  const handleFetchData = async () => {
    if (orgData) {
      try {
        setTags(orgData.tags || []); // Set the tags
        const token = await getOrRefreshFirebaseToken();
        setToken(await getOrRefreshFirebaseToken());
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  const handleColorChange = (color) => {
    setColor(color);
  };
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCreateTag = async () => {
    const newTag = {
      nom: nom ? nom : "Nouveau Tag",
      colorint: HexColorToFlutter(color),
      org_id: orgData.id,
    };
    const newTags = tags;
    newTags.push(newTag);
    await updateDocDataFieldApi(doc(dbCentral, "org", orgData.id), "tags", newTags, prefix);
    setIsModalOpen(false);
    handleClickVariant("Tag créé avec succès", "success");
  };
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDelete = async () => {
    let tag = selected_tag;
    // check if any folder uses this tag
    let folders = appState?.saved_data?.folders || [];
    folders = folders.filter((f) =>
      f.tags.map((t) => t.nom + t.colorint).includes(tag.nom + tag.colorint)
    );
    if (folders.length > 0) {
      handleClickVariant(
        "Ce tag est utilisé par " + folders.length + " dossiers",
        "error"
      );
      return;
    }

    const newTags = tags.filter((t) => t !== tag);
    await updateDocDataFieldApi(orgData.id, "tags", newTags, prefix);
    handleClickVariant("Tag supprimé avec succès", "success");
    setSelectedTag(null);
    setIsModalOpen(false);
    setIsColorOpen(false);
  };

  const handleSaveTagColor = async () => {
    const newTags = tags.map((tag) => {
      if (tag === selected_tag) {
        tag.colorint = HexColorToFlutter(tag_color);
      }
      return tag;
    });
    await updateDocDataFieldApi(doc(dbCentral, "org", orgData.id), "tags", newTags, prefix);
    setIsColorOpen(false);
    handleClickVariant("Couleur du tag modifiée avec succès", "success");
  };

  const [color, setColor] = useState("#fff");
  const [tag_color, setTagColor] = useState("#fff");
  const [selected_tag, setSelectedTag] = useState(null);

  return (
    <div className="overflow-auto flex flex-col items-start justify-start w-full h-full pl-5    pb-10">
      <Modal1 isOpen={isModalOpen} onClose={handleCloseModal} color="#fff">
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <TextField2T
            label="Nom"
            value={nom}
            onChange={(e) => setNom(e.target.value)}
          />
          <Space y={20} />
          <HexColorPicker color={color} onChange={handleColorChange} />
          <Space y={20} />
          <div className="flex flex-row justify-between">
            <SecondaryButton onClick={handleCloseModal}>Fermer</SecondaryButton>
            <Space x={20} />
            <PrimaryButton
              onClick={handleCreateTag}
              disabled={!nom || nom === "" || color === ""}
            >
              Valider
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <Modal1 isOpen={isColorOpen} onClose={() => setIsColorOpen(false)}>
        <div className="bg-white flex flex-col p-6 w-fit rounded-3xl gap-3 ">
          {" "}
          <SecondaryButton onClick={handleDelete}>
            Supprimer
          </SecondaryButton>{" "}
          <HexColorPicker
            color={tag_color}
            onChange={(color) => setTagColor(color)}
          />
          <PrimaryButton onClick={handleSaveTagColor}>
            Enregistrer
          </PrimaryButton>
        </div>
      </Modal1>
      <div className="text-h1 font-bold text-left">Tags</div>
      <Space y={20} />
      <div className="max-w-c400 w-full">
        <div className="mb-4">
          <div className="text-h1 font-medium">Tags existants</div>
        </div>
        <Space y={20} />

        <div className="flex flex-wrap w-c800 gap-2">
          {tags
            .sort((a, b) => a.nom.localeCompare(b.nom))

            .map((tag, index) => (
              <div key={tag.nom + index.toString()}>
                <div
                  onClick={() => {
                    setSelectedTag(tag);
                    setTagColor(flutterColorToHex(tag.colorint));
                    setIsColorOpen(true);
                  }}
                  className="flex w-full flex-col rounded-full bg-neutral-100 cursor-pointer "
                  style={{
                    backgroundColor: flutterColorToHex(tag.colorint),
                    borderColor: flutterColorToHex(tag.colorint),
                  }}
                >
                  <div className="flex w-full items-center justify-between pl-3  rounded-lg">
                    <div
                      className="text-h3 font-light "
                      style={{
                        color: isColorTooDark(flutterColorToHex(tag.colorint))
                          ? "white"
                          : "black",
                      }}
                    >
                      {tag.nom}
                    </div>
                    <div className="ml-2 flex flex-row items-center bg-wshadow_50 border-1 border-shadow_25 rounded-full ">
                      <div className="p-1 ">
                        <Icon1
                          icon_name="settings"
                          size="16px"
                          fill="black"
                          hover_color={"purple"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}{" "}
          <div className="w-full flex flex-row-reverse mt-4">
            <Space x={5} />
            <PrimaryButton onClick={handleOpenModal}>
              <div className="flex flex-row content-center">
                <Space x={5} />
                Nouveau Tag
              </div>
            </PrimaryButton>
          </div>
        </div>
      </div>{" "}
      <Space y={30} />
      <div className="mb-4">
        <div className="text-h1 font-medium text-shadow_50">Idées de tags</div>{" "}
        <div className="text-h3 text-shadow_50 mt-2">Cliquez pour utiliser</div>
        {
          <div className="flex flex-row flex-wrap gap-2 mt-4 max-w-c700">
            {ideas.map((idea, index) => (
              <div
                onClick={() => {
                  setNom(idea);
                  setColor("#fff");
                  setIsModalOpen(true);
                }}
                key={idea + index.toString()}
                className="bg-neutral-200 rounded-xl px-2 py-1 cursor-pointer hover:shadow-md hover:bg-white"
              >
                <div className="text-h3 ">{idea}</div>
              </div>
            ))}
          </div>
        }
      </div>
      <Space y={20} />
    </div>
  );
}

export default Tags;
